<template>
    <!-- 次卡 -->	
    <section>
		<!--工具条-->
		<!-- <el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form :inline="true" :model="filters" style="float: right;">
				<el-form-item>
					<el-input v-model="filters.name" placeholder="项目名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button size="width:100%; height:100%;" type="primary" v-on:click="getRechargeableConsumption" icon="el-icon-search">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleAdd">添加消费项目</el-button>
				</el-form-item>
			</el-form>
		</el-col> -->
         <br>
		<!--列表-->
		<el-table :data="WeiXinSett" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;">
			<el-table-column type="selection" width="55">
			</el-table-column>
<el-table-column type="expand">
      <template slot-scope="props">
        <el-form label-position="left" >
          <el-form-item label="应用名称">
            <span>{{ props.row.AppName }}</span>
          </el-form-item>
          <el-form-item label="Appid">
            <span>{{ props.row.Appid }}</span>
          </el-form-item>
          <el-form-item label="Appsecret">
            <span>{{ props.row.Appsecret }}</span>
          </el-form-item>
          <el-form-item label="返回类型">
            <span>{{ props.row.Response_type }}</span>
          </el-form-item>
          <el-form-item label="作用域">
            <span>{{ props.row.Scope }}</span>
          </el-form-item>
          <el-form-item label="自定状态">
            <span>{{ props.row.State }}</span>
          </el-form-item>
          <el-form-item label="授权地址">
            <span>{{ props.row.Url }}</span>
          </el-form-item>
		  <el-form-item label="回调地址">
            <span>{{ props.row.Redirect_uri }}</span>
          </el-form-item>
        </el-form>
      </template>
    </el-table-column>
			<el-table-column prop="AppName" label="应用名称" width="150" sortable>
			</el-table-column>
			<el-table-column prop="Appid" label="Appid" min-width="180" sortable>
			</el-table-column>
			<el-table-column prop="Appsecret" label="Appsecret" min-width="180" sortable>
			</el-table-column>		
            <el-table-column prop="Response_type" label="返回类型" width="120" sortable>
			</el-table-column>
            <el-table-column prop="Scope" label="作用域" min-width="120"  sortable>
			</el-table-column>				
			
            <!-- <el-table-column prop="Url" label="授权地址" width="120" sortable>
			</el-table-column>
        	<el-table-column prop="Redirect_uri" label="回调地址" width="120" sortable>
			</el-table-column>	    	            	 -->
			<el-table-column prop="Remark" label="备注" min-width="180" sortable>
			</el-table-column>
			<el-table-column label="操作" width="150" fixed="right">
				<template  slot-scope="scope">
					<el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
					<!-- <el-button type="danger" size="small" @click="handleDel(scope.row)">删除</el-button> -->
				</template>
			</el-table-column>
		</el-table>

		<!-- 工具条 -->
		<!-- <el-col :span="24" class="toolbar">
			<el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button>
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="total" style="float:right;">
			</el-pagination>
		</el-col> -->

		<!--编辑界面-->
		<el-dialog title="编辑" v-model="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">				
				<el-form-item label="应用名称" prop="AppName">
					<el-input v-model="editForm.AppName" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="Appid" prop="Appid">
					<el-input v-model="editForm.Appid" auto-complete="off"></el-input>
				</el-form-item>
                <el-form-item label="Appsecret" prop="Appsecret">
					<el-input v-model="editForm.Appsecret" auto-complete="off"></el-input>
				</el-form-item>
                <el-form-item label="回调地址" prop="Redirect_uri">
					<el-input v-model="editForm.Redirect_uri" auto-complete="off"></el-input>
				</el-form-item>
                <el-form-item label="返回类型" prop="Response_type">
					<el-input v-model="editForm.Response_type" auto-complete="off"></el-input>
				</el-form-item>
                <el-form-item label="作用域" prop="Scope">
					<el-input v-model="editForm.Scope" auto-complete="off"></el-input>
				</el-form-item>
                <el-form-item label="自定状态" prop="State">
					<el-input v-model="editForm.State" auto-complete="off"></el-input>
				</el-form-item>
                <el-form-item label="授权地址" prop="Url">
					<el-input v-model="editForm.Url" auto-complete="off"></el-input>
				</el-form-item>          
				<el-form-item label="备注">
					<el-input type="textarea" v-model="editForm.Remark"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>

		<!--新增界面-->
		<!-- <el-dialog title="新增项目" v-model="addFormVisible" :close-on-click-modal="false">
			<el-form :model="addForm" label-width="120px" :rules="addFormRules" ref="addForm">
				<el-form-item label="项目名称" prop="Name">
					<el-input v-model="addForm.Name" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="消费金额" prop="Amount">
					<el-input v-model="addForm.Amount" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="备注">
					<el-input type="textarea" v-model="addForm.Remark"></el-input>
				</el-form-item>							
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="addFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
			</div>
		</el-dialog> -->
	</section>
</template>
<script>
	import util from '../../common/js/util'

import {WeiXinSettPagList,editWeiXinSett} from '../../api/api';
export default {
	data(){
		return {
            WeiXinSett:[],//table 列表
            listLoading:false,
				total: 0,
				page: 0,
           //编辑数据相关
            editFormVisible:false,
            editLoading:false,
            editForm:{},
            editFormRules:{}
		}
	},
	methods:{
         handleEdit(index, row){
             this.editFormVisible=true;
           	this.editForm = Object.assign({}, row);

         },
        getTableList(){
            let para = {
					PageIndex: this.page-1,					
					PageSize:10,
				};
				this.listLoading = true;
              WeiXinSettPagList(para).then((res)=>{
                 	this.total = res.data.TotleCount;
					this.WeiXinSett =res.data.Data;

					this.listLoading = false;

              }).catch(error=>{
                  alert('系统错误');
                });
							
         },
		editSubmit: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.editLoading = true;
							//NProgress.start();
							let para = Object.assign({}, this.editForm);
							// para.Birthday = (!para.Birthday || para.Birthday == '') ? '' : util.formatDate.format(new Date(para.Birthday), 'yyyy-MM-dd');
							editWeiXinSett(para).then((res) => {
								this.editLoading = false;
								//NProgress.done();
								// console.log(res);
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
								});
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								}
								
								this.$refs['editForm'].resetFields();
								this.editFormVisible = false;
								this.getTableList();
							}).catch(error=>{
                            alert('系统错误');
                            });
							
						});
					}
				});
			},
		handleCurrentChange(val) {
				this.page = val;
				// this.getRechargeableConsumption();
			},
		selsChange: function (sels) {
				this.sels = sels;
			},
        

	}
	,
		mounted() {
        this.getTableList();

		}
}
</script>



// WEBPACK FOOTER //
// WeiXinSett.vue?37dec573